module.exports = __webpack_public_path__ + "static/media/ray-future.95d2c79c.jpg";